import { render, staticRenderFns } from "./PolicyExcessInfo.vue?vue&type=template&id=43a58650&"
import script from "./PolicyExcessInfo.vue?vue&type=script&lang=js&"
export * from "./PolicyExcessInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports